<template>
  <div>
    <data-table class="table-custom" ref="dataTable" :option="option">
      <template slot="headAction">
        <a-button style="margin-left:10px" type="primary" @click="syncGoods(1)"
          >同步物品</a-button
        >
        <a-button style="margin-left:10px" type="danger" @click="syncGoods(2)"
          >同步全部物品</a-button
        >
      </template>
    </data-table>
    <a-modal
      title="选择账项类别"
      :visible="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
      @cancel="handleCancel"
    >
      <div style="margin:20px 0">
        <em style="color:#f00">*</em>账项类别：
        <a-select
          style="width:200px"
          v-model="AccountTypeId"
          @change="handleChange"
          allowClear
        >
          <a-select-option
            v-for="(item, index) in accoutTypeList"
            :value="item.Id"
            :key="index"
            >{{ item.Text }}</a-select-option
          >
        </a-select>
        <span style="color:#f00;margin-left:5px">{{ errorTip }}</span>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
export default {
  components: {
    DataTable
  },
  data() {
    return {
      option: {},
      apiOptions: {},
      Status: false,
      selectIds: [],
      AccountTypeId: "",
      confirmLoading: false,
      visible: false,
      accoutTypeList: [],
      errorTip: ""
    };
  },
  created() {
    const _this = this;
    //api数据集中填写
    _this.apiOptions = {
      api: "Warehouse_GoodsList",
      addApi: "Warehouse_GoodsAdd",
      editApi: "Warehouse_GoodsEdit",
      delApi: "Warehouse_GoodsDel",
      syncGoodsApi: "Warehouse_SyncGoods"
    };
    this.getAccountType();
    //形成表格表单
    _this.option = {
      //搜索框内容
      headSearch: {
        colnum: 2,
        content: [
          {
            label: "物品名称",
            name: "Keyword",
            props: {
              placeholder: "物品名称"
            }
          },
          {
            label: "显示禁用项",
            name: "Status",
            type: "checkbox",
            option: {
              initialValue: false
            },
            onChange: e => {
              this.Status = e.target.checked;
              this.$refs.dataTable.headSearch();
            }
          }
        ],
        onSubmitBefore: values => {
          values.Status = this.Status ? null : 1;
          // values.PageIndex = 0;
          return values;
        }
      },
      //弹出窗内容
      form: {
        title: "物品",
        width: 900,
        content: [
          {
            label: "名称",
            name: "Name",
            option: {
              rules: [{ required: true, message: "请填写名称" }]
            }
          },
          {
            label: "类别",
            name: "CategoryId",
            type: "select",
            api: "Common_GetSelect",
            param: {
              Types: "GoodsCategory"
            },
            dataField: "Data.GoodsCategory"
          },
          {
            label: "代码",
            name: "Code",
            option: {
              rules: [{ required: true, message: "请填写代码" }]
            }
          },
          {
            label: "单位",
            name: "UnitId",
            type: "select",
            api: "MaintenancePage_List",
            param: {
              Type: "Unit",
              PageIndex: 0,
              PageSize: 1000
            },
            dataField: "Data.Datas",
            valueField: "Id",
            textField: "Name",
            option: {
              rules: [{ required: true, message: "请选择单位" }]
            }
          },
          {
            label: "规格",
            name: "Spec"
          },
          {
            label: "条码",
            name: "BarCode"
          },
          {
            label: "状态",
            name: "Status",
            type: "select",
            valueField: "value",
            textField: "text",
            data: [
              {
                value: 1,
                text: "启用"
              },
              {
                value: 0,
                text: "禁用"
              }
            ]
          },
          {
            label: "最低库存数",
            name: "MinStock",
            type: "number",
            option: {
              rules: [{ required: true, message: "请填写最低库存数" }]
            }
          },
          {
            label: "备注",
            name: "Remark",
            type: "textarea",
            colnum: 2
          }
        ],
        //新增弹窗
        add: {
          submitApi: _this.apiOptions.addApi,
          onOpenAfter: () => {
            return { Status: 1, MinStock: 0 };
          },
          onSubmitBefore: values => {
            values.BarCode = values.BarCode ? values.BarCode : 0;
            values.Spec = values.Spec ? values.Spec : 0;
            return values;
          }
        },
        //编辑弹窗
        edit: {
          submitApi: _this.apiOptions.editApi,
          onOpenAfter: values => {
            values.BarCode = values.BarCode === "0" ? "" : values.BarCode;
            values.Spec = values.Spec === "0" ? "" : values.Spec;
            return values;
          },
          onSubmitBefore: values => {
            values.BarCode = values.BarCode ? values.BarCode : 0;
            values.Spec = values.Spec ? values.Spec : 0;
            return values;
          }
        },
        del: {
          submitApi: _this.apiOptions.delApi,
          onSubmitBefore: values => {
            return values;
          }
        }
      },
      //表格内容
      grid: {
        api: _this.apiOptions.api, //数据表格api
        rowSelect: true,
        params: { Status: 1 },
        props: {
          scroll: {
            y: window.document.body.clientHeight - 320
          }
        },
        columns: [
          {
            title: "序号",
            width: "40px", //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          {
            title: "物品名称",
            dataIndex: "Name",
            width: "10%",
            align: "center"
          },
          {
            title: "物品代码",
            dataIndex: "Code",
            width: "10%",
            align: "center"
          },
          {
            title: "物品分类",
            dataIndex: "CategoryName",
            width: "8%",
            align: "center"
          },
          {
            title: "条码",
            dataIndex: "BarCode",
            width: "12%",
            align: "center"
          },
          {
            title: "状态",
            width: "6%",
            dataIndex: "StatusName",
            align: "center"
          },
          {
            title: "最低库存数",
            width: "7%",
            dataIndex: "MinStock",
            align: "center"
          },
          {
            title: "单位",
            width: "5%",
            dataIndex: "UnitName",
            align: "center"
          },
          {
            title: "规格",
            width: "8%",
            dataIndex: "Spec",
            align: "center"
          },
          {
            title: "备注",
            dataIndex: "Remark",
            align: "left"
          },
          {
            title: "操作",
            width: "15%",
            dataIndex: "Id",
            key: "action",
            align: "center",
            scopedSlots: { customRender: "rowAction" }
          }
        ],
        pageChange: json => {
          return {
            ...json,
            Status: this.Status ? null : 1
          };
        }
      }
    };
  },
  methods: {
    syncGoods(type) {
      this.AccountTypeId = "";
      let selectRows = this.$refs.dataTable.getSelecteds();
      if (type == 1) {
        if (!selectRows || !selectRows.length) {
          this.$message.error("请选择同步物品!");
          return false;
        }
        this.selectIds = selectRows.map(item => item.Id);
      } else {
        this.selectIds = [];
      }
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
      this.errorTip = "";
      this.AccountTypeId = "";
    },
    handleOk() {
      if (!this.AccountTypeId) {
        this.errorTip = "请选择账项类别";
        return false;
      }
      const params = {
        IdList: this.selectIds,
        AccountTypeId: this.AccountTypeId
      };
      this.confirmLoading = true;
      this.$post(this.apiOptions.syncGoodsApi, params)
        .then(() => {
          this.visible = false;
          this.confirmLoading = false;
          this.$refs.dataTable.headSearch();
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    },
    handleChange(value) {
      if (value) {
        this.errorTip = "";
      }
    },
    getAccountType() {
      this.$post("Common_GetSelect", { Types: "accouttype" }).then(res => {
        this.accoutTypeList = res.Data.accouttype;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.table-custom {
  /deep/ .head {
    /deep/ .head-search-box {
      /deep/ .ant-form-item-label {
        width: 140px;
      }
    }
  }
}
</style>
